import React from "react";
import { AddressResponse } from "../service/addressService";
import { Button } from "@components/shadcn-ui/button";
import { Card, CardContent, CardHeader } from "@components/shadcn-ui/card";
import { Badge } from "@components/shadcn-ui/badge";
import { Edit, Trash2 } from "lucide-react";

interface AddressCardProps {
  address: AddressResponse;
  onDelete: (addressId: string) => void;
  onEdit: (address: AddressResponse) => void;
}

export const AddressCard: React.FC<AddressCardProps> = ({
  address,
  onDelete,
  onEdit,
}) => {
  console.log("logging just to avoid refactoring on delete code", onDelete);
  const getAddressTypeColor = (type: string) => {
    switch (type) {
      case "PERMANENT":
        return "bg-green-100 text-green-800";
      case "CURRENT":
        return "bg-blue-100 text-blue-800";
      case "OFFICE":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getOwnershipBadge = (ownership: string) => {
    switch (ownership) {
      case "OWNED":
        return <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">Owned</Badge>;
      case "RENTED":
        return <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">Rented</Badge>;
      case "LEASED":
        return <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">Leased</Badge>;
      case "COMPANY_PROVIDED":
        return <Badge variant="outline" className="bg-purple-50 text-purple-700 border-purple-200">Company Provided</Badge>;
      case "FAMILY_OWNED":
        return <Badge variant="outline" className="bg-indigo-50 text-indigo-700 border-indigo-200">Family Owned</Badge>;
      default:
        return <Badge variant="outline">{ownership}</Badge>;
    }
  };

  return (
    <Card className="mb-4">
      <CardHeader className="pb-2 pt-4 px-4 flex flex-row justify-between items-center">
        <div className="flex items-center gap-2">
          <Badge className={getAddressTypeColor(address.type)}>
            {address.type}
          </Badge>
          {getOwnershipBadge(address.ownership)}
        </div>
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(address)}
            className="h-8 w-8 p-0"
          >
            <Edit className="h-4 w-4" />
          </Button>
          {/*TODO: enable once the delete API is ready*/}
          {/*<Button*/}
          {/*  variant="ghost"*/}
          {/*  size="sm"*/}
          {/*  onClick={() => onDelete(address.id)}*/}
          {/*  className="h-8 w-8 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"*/}
          {/*>*/}
          {/*  <Trash2 className="h-4 w-4" />*/}
          {/*</Button>*/}
        </div>
      </CardHeader>
      <CardContent className="px-4 py-2">
        <div className="text-sm">
          <p className="font-medium">{address.line1}</p>
          {address.line2 && <p>{address.line2}</p>}
          {address.landmark && <p>Landmark: {address.landmark}</p>}
          <p>
            {address.city}, {address.state}, {address.postalCode}
          </p>
          <p>{address.country}</p>
          <div className="mt-2 text-gray-600 text-xs">
            <p>Years of stay: {address.yearsOfStay}</p>
            {address.monthlyRent && <p>Monthly rent: ₹{address.monthlyRent}</p>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
